<template>
  <div class="mod__no-data">
    <div class="no-data-box">
      <Icon name="block" class="no-data-icon" />
      <slot>
        <span class="no-data-text">{{ text || $t('no-data') }}</span>
      </slot>
    </div>
  </div>
</template>
<script>
import Icon from 'com/Icon'
export default {
  name: 'NoData',
  components: { Icon },
  props: ['text']
}
</script>
<style lang="less" type="text/less">
@import '~uikit';
.mod__no-data {
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;

  .no-data-box {
    border-radius: 3px;
    padding: 12px 15px;
    background-color: var(--special-color);
    font-size: 14px;
    min-width: 20%;
    text-align: center;
    .no-data-icon,
    .no-data-text {
      display: inline-block;
      vertical-align: middle;
      font-weight: 500;
      color: @light-grey;
    }
    .no-data-icon {
      font-size: 18px;
    }
  }
}
</style>
